import { Circle, Path, Svg } from '@react-pdf/renderer';

const iconColor = '#5f6368';

export function SentIcon() {
  return (
    <Svg width={18} height={18} viewBox="0 0 24 24">
      <Path d="M8.5 6.5v11l9-5.5-9-5.5z" stroke={iconColor} strokeWidth={1.6} strokeLinejoin="round" fill="none" />
    </Svg>
  );
}

export function SignedIcon() {
  return (
    <Svg width={18} height={18} viewBox="0 0 24 24">
      <Path
        d="M4.5 16.4c2-.8 2.8-4.2 4.2-4.2 1.1 0 .7 2.8 2.1 2.8 1.6 0 1.8-4.8 3.2-4.8 1.1 0 .7 3 2 3 1 0 1.3-1.4 3.5-2.2"
        stroke={iconColor}
        strokeWidth={1.5}
        strokeLinecap="round"
        fill="none"
      />
      <Path d="M15.2 4.8l3.6 3.6" stroke={iconColor} strokeWidth={1.5} strokeLinecap="round" fill="none" />
    </Svg>
  );
}

export function CompletedIcon() {
  return (
    <Svg width={18} height={18} viewBox="0 0 24 24">
      <Circle cx={12} cy={12} r={7.2} stroke={iconColor} strokeWidth={1.5} fill="none" />
      <Path
        d="M8.3 12.2l2.4 2.4 5-5.1"
        stroke={iconColor}
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </Svg>
  );
}
